let result;

export const getPointsOfInterest = () => {
  if (result) return Promise.resolve(result);
  return import('./widget-points-of-interest').then((module) => {
    result = module;
    return module;
  });
};